module.exports = __webpack_public_path__ + "static/media/javascript.46524a43.svg";